import { partnerSupplier } from '@/utils/environment';
import { useAuthenticatedUserContext } from '@/contexts/user-context';
import { useEffect, useRef } from 'react';

export const useVitally = () => {
  const { supplierEmployeeRole, user } = useAuthenticatedUserContext();

  const initializedRef = useRef(false);

  useEffect(() => {
    if (initializedRef.current || !supplierEmployeeRole || !window.Vitally) {
      return;
    }

    try {
      window.Vitally.account({
        accountId: partnerSupplier.businessOrganizationUUID,
        traits: {
          name: partnerSupplier.fullName,
        },
      });

      window.Vitally.user({
        accountId: partnerSupplier.businessOrganizationUUID,
        traits: {
          email: user.contact_info.email,
          name: user.name,
          pepperEmployeeRole: supplierEmployeeRole,
          pepperIsSupplierEmployee: true,
          phone: user.contact_info.phone_number,
        },
        userId: user.uuid,
      });

      window.Vitally.nps('survey', {
        productName: 'Pepper',
      });
    } catch {
      // Do nothing
    }

    initializedRef.current = true;
  }, [supplierEmployeeRole, user]);
};
